module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Russia.56f044ee.jpg";